import { render } from "./AppParts.vue?vue&type=template&id=66c25b2a"
import script from "./AppParts.vue?vue&type=script&lang=js"
export * from "./AppParts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__